
import makerjs from "makerjs";

function B03(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param, R = Param[2].param,T = Param[3].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       r = R * 1 * myZoom,
       t = T * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 =b-t , x3 = b, x4=b,y0 = 0, y1 = l, y2 = r, y3 = r,y4=0,glassH = r, glassW = b,h=r,w=b;

   if (b !== 0) {
       var TxtB = B;
   }  if (l !== 0) {
  var TxtL = "L="+L;
}
if (r !== 0) {
    var TxtR = R;
}
if (t !== 0) {
    var TxtT = T;
}



   var drawAbnormalShapeB03 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "RightDLine": new makerjs.paths.Line([x3, y3], [x4, y4]),
        "BottomLine": new makerjs.paths.Line([x4, y4], [x0, y0]),
       }
   };
   var drawAbnormalShapeB03MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
        "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
       }
   };
   var drawAbnormalShapeB03MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x4+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x4, y3], [x4+ 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
       }
   };
   var drawAbnormalShapeB03MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x4, y4- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y4], [x4, y4 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB03MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y3+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB03MarkB, TxtB, [x0, y0 - 2 * markShift], [x4, y4 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB03MarkT, TxtT, [x2, y2 + 2 * markShift], [x3, y3 + 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeB03MarkR, TxtR, [x4 + 2 * markShift, y4], [x4 + 2 * markShift, y3]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB03MarkL, TxtL, [x0-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB03: drawAbnormalShapeB03,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB03: drawAbnormalShapeB03,
        drawAbnormalShapeB03MarkL: drawAbnormalShapeB03MarkL,
        drawAbnormalShapeB03MarkB:drawAbnormalShapeB03MarkB,
        drawAbnormalShapeB03MarkR:drawAbnormalShapeB03MarkR,
        drawAbnormalShapeB03MarkT:drawAbnormalShapeB03MarkT,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B03;